import { useFormik } from "formik";
import React from "react";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Spinner from "react-bootstrap/Spinner";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";
import { register } from "../../../Services/AuthService";
import { setItem } from "../../../Services/Storage";

const validationSchema = yup.object({
  phone: yup
    .string()
    .matches(/^(3)([0-9]{9})$/g, "Please enter a valid number!")
    .required("This field is required..."),
  f_name: yup.string().required("This field is required..."),
  l_name: yup.string().required("This field is required..."),
  email: yup
    .string()
    .email("Please enter a valid email")
    .required("This field is required..."),
  password: yup.string().required("This field is required..."),
  passwordConfirmation: yup
    .string()
    .oneOf([yup.ref("password"), null], "Passwords must match")
    .required("This field is required..."),
});

export const SignUp = () => {
  const [submitting, setSubmitting] = React.useState(false);
  const userType = useSelector((x) => x.UserType);
  const config = useSelector((x) => x.Config);
  const loggedIn = useSelector((x) => x.LoggedIn);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const referred_by = new URLSearchParams(location.search).get("ref");
  // console.log(`refcode`,referral_code);

  setItem("referred_by", referred_by);
  // console.log(`rb`,referred_by);
  
  React.useEffect(() => {
    const lastPage = sessionStorage.getItem("lastPage");
    if (loggedIn) navigate(lastPage || "/app", { replace: true });
  }, []);

  const formik = useFormik({
    initialValues: {
      f_name: "",
      l_name: "",
      phone: "",
      email: "",
      password: "",
      fcm_token: "dfskjfkjshfksdhfdskhfsdfkh",
    },
    validationSchema,
    onSubmit: (v) => {
      const payload = { 
        ...v, 
        phone: `+92${v.phone}`,
        referred_by: referred_by || null
       };
      console.log(payload);
      setSubmitting(true);
      register(payload).then(
        (res) => {
          if (config?.customer_verification) {
            navigate("/app/phone-verification", { replace: true });
          }
          dispatch({ type: "setToken", payload: res.token });
          dispatch({ type: "setLoggedIn", payload: true });
          if (!config?.customer_verification) {
            const lastPage = sessionStorage.getItem("lastPage");
            navigate(lastPage || "/app", { replace: true });
          }
          setSubmitting(true);
        },
        ({ errors }) => {
          setSubmitting(false);
          if (typeof errors == "string") {
            toast.error(errors, { autoClose: 5000 });
          } else {
            if (errors?.length > 0) {
              errors.forEach((z) => {
                toast.error(z.message, { autoClose: 5000 });
              });
            }
          }
        }
      );
    },
  });

  return (
    <>
      <div className="container-fluid sign-up-form bg-white">
        <div
          className="row justify-content-between"
          style={{ minHeight: "100vh" }}
        >
          <div className="col-md-7 col-12">
            <div className="row">
              <div className="col-12 p-4 d-flex justify-content-center justify-content-md-start">
                <img
                  src={process.env.PUBLIC_URL + "/assets/images/logo.png"}
                  alt=""
                  style={{ width: "198px", height: "33px" }}
                />
              </div>
              <div
                style={{ height: "calc(90vh - 65px)" }}
                className="col-12 d-flex justify-content-center flex-column align-items-center"
              >
                <form
                  className="col-lg-6 col-md-8 col-11"
                  onSubmit={formik.handleSubmit}
                >
                  <div>
                    <span
                      style={{
                        fontSize: "35px",
                        display: "block",
                        color: "#232323",
                      }}
                      className="fw-bold"
                    >
                      Sign Up
                    </span>
                    <span
                      style={{
                        fontSize: "18px",
                        display: "block",
                        color: "#969696",
                      }}
                    >
                      Sign up to enjoy features of Jabchaho
                    </span>
                  </div>
                  <Form.Group className="mb-3 mt-4" controlId="phone">
                    <InputGroup>
                      <InputGroup.Text>+92</InputGroup.Text>
                      <Form.Control
                        type="text"
                        name="phone"
                        placeholder="3xxxxxxxxx"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className={`${
                          Boolean(formik.errors.phone) && formik.touched.phone
                            ? "is-invalid"
                            : ""
                        }`}
                      />
                    </InputGroup>
                    {Boolean(formik.errors.phone) && formik.touched.phone ? (
                      <Form.Text className="text-danger">
                        {formik.errors.phone}
                      </Form.Text>
                    ) : null}
                  </Form.Group>
                  <div className="d-flex flex-wrap">
                    <div className="pe-1" style={{ maxWidth: "50%" }}>
                      <Form.Group className="mb-3" controlId="f_name">
                        <Form.Control
                          type="text"
                          name="f_name"
                          style={{ padding: "0.375rem 0.75rem" }}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          placeholder="First Name"
                          className={`${
                            Boolean(formik.errors.f_name) &&
                            formik.touched.f_name
                              ? "is-invalid"
                              : ""
                          }`}
                        />
                        {Boolean(formik.errors.f_name) &&
                        formik.touched.f_name ? (
                          <Form.Text className="text-danger">
                            {formik.errors.f_name}
                          </Form.Text>
                        ) : null}
                      </Form.Group>
                    </div>
                    <div className="ps-1" style={{ maxWidth: "50%" }}>
                      <Form.Group className="mb-3" controlId="l_name">
                        <Form.Control
                          type="text"
                          name="l_name"
                          style={{ padding: "0.375rem 0.75rem" }}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          placeholder="Last Name"
                          className={`${
                            Boolean(formik.errors.l_name) &&
                            formik.touched.l_name
                              ? "is-invalid"
                              : ""
                          }`}
                        />
                        {Boolean(formik.errors.l_name) &&
                        formik.touched.l_name ? (
                          <Form.Text className="text-danger">
                            {formik.errors.l_name}
                          </Form.Text>
                        ) : null}
                      </Form.Group>
                    </div>
                  </div>
                  <Form.Group className="mb-3" controlId="email">
                    <Form.Control
                      type="text"
                      name="email"
                      autoComplete="email"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      placeholder="Email"
                      className={`${
                        Boolean(formik.errors.email) && formik.touched.email
                          ? "is-invalid"
                          : ""
                      }`}
                    />
                    {Boolean(formik.errors.email) && formik.touched.email ? (
                      <Form.Text className="text-danger">
                        {formik.errors.email}
                      </Form.Text>
                    ) : null}
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="password">
                    <Form.Control
                      type="password"
                      name="password"
                      placeholder="Password"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className={`${
                        Boolean(formik.errors.password) &&
                        formik.touched.password
                          ? "is-invalid"
                          : "mb-3"
                      }`}
                    />
                    {Boolean(formik.errors.password) &&
                    formik.touched.password ? (
                      <Form.Text className="text-danger d-block">
                        {formik.errors.password}
                      </Form.Text>
                    ) : null}
                  </Form.Group>
                  <Form.Group className="mb-4">
                    <Form.Control
                      type="password"
                      id="passwordConfirmation"
                      name="passwordConfirmation"
                      placeholder="Confirm Password"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className={`${
                        Boolean(formik.errors.passwordConfirmation) &&
                        formik.touched.passwordConfirmation
                          ? "is-invalid"
                          : ""
                      }`}
                    />
                    {Boolean(formik.errors.passwordConfirmation) &&
                    formik.touched.passwordConfirmation ? (
                      <Form.Text className="text-danger">
                        {formik.errors.passwordConfirmation}
                      </Form.Text>
                    ) : null}
                  </Form.Group>
                  <button className="login-btn" type="submit">
                    {submitting ? (
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                      />
                    ) : null}
                    Sign Up
                  </button>
                  <small className="text-center my-4 d-block">
                    Already have an account?{" "}
                    <Link
                      className="ms-1 fw-semibold app-text-primary"
                      to="/app/login"
                      style={{ textDecoration: "none" }}
                    >
                      Login
                    </Link>
                  </small>
                  {/* <small className="text-center mt-2 d-block">
                    <Link
                      className="ms-1 fw-semibold app-text-primary"
                      to="/forgot-password"
                    >
                      Forgot Password?
                    </Link>
                  </small> */}
                  {/* {userType != false ? (
                    <>
                      <div className="div position-relative">
                        <hr className="border-2" />
                        <div
                          className="position-absolute w-100 text-center"
                          style={{ top: "-13px" }}
                        >
                          <small
                            className="px-2 fw-semibold text-muted"
                            style={{ backgroundColor: "#fff" }}
                          >
                            OR
                          </small>
                        </div>
                      </div>
                      <small className="text-center mt-4 pb-2 d-block">
                        <span
                          className="ms-1 fw-semibold app-text-primary text-uppercase cursor-pointer"
                          onClick={() => {
                            dispatch({ type: "setUserType", payload: false });
                            navigate("/app");
                          }}
                        >
                          Continue as Guest
                        </span>
                      </small>
                    </>
                  ) : null} */}
                </form>
              </div>
            </div>
          </div>
          <div className="col-md-5 d-none d-md-block py-2">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/signup.png"}
              alt=""
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                objectPosition: "center",
                maxHeight: "95vh",
                borderRadius: "24px",
                backgroundColor: "#aaa",
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};
